import React, { useState, useEffect, useCallback, useMemo } from 'react';
import api from '../services/api';

const fmt = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const statusLabel = (s) => s === 'new' ? 'YENİ' : s === 'processing' ? 'İŞLEMDE' : s === 'awaiting_mgmt' ? 'DEKONT KONTROLÜNDE' : s === 'approved' ? 'ONAYLANDI' : s === 'rejected' ? 'REDDEDİLDİ' : (s || '').toUpperCase();
const statusColor = (s) => s === 'approved' ? '#28a745' : s === 'rejected' ? '#dc3545' : s === 'awaiting_mgmt' ? '#6f42c1' : s === 'processing' ? '#f6bb42' : '#5d9cec';

// Tüm panellerdeki çekimleri tek sayfada gösterir; filtre/arama ile.
const AllWithdrawalsPage = () => {
    const [rows, setRows] = useState([]);
    const [panels, setPanels] = useState([]);
    const [firmMap, setFirmMap] = useState({}); // panelId -> firma adı
    const [filters, setFilters] = useState({ search: '', status: '', panelId: '', firma: '', startDate: '', endDate: '' });

    const fetchAll = useCallback(async () => {
        try {
            const [wRes, panelsRes, fmRes] = await Promise.all([api.getWithdrawals({}), api.getPanels(), api.getFirmPanelMap()]);
            setRows(wRes.data);
            setPanels(panelsRes.data);
            const m = {}; (fmRes.data || []).forEach(x => { m[x.panelId] = x.firma; });
            setFirmMap(m);
        } catch (e) { console.error('Tüm çekimler çekilemedi', e); }
    }, []);

    useEffect(() => {
        document.title = 'PayzoPay - Tüm Çekimler';
        fetchAll();
        const iv = setInterval(fetchAll, 8000);
        return () => clearInterval(iv);
    }, [fetchAll]);

    const panelName = (pid) => { const p = panels.find(x => x.panelId === pid); return p ? (p.name || p.panelId) : (pid || '-'); };
    const firmaName = (pid) => firmMap[pid] || '-';
    const firmaOptions = useMemo(() => Array.from(new Set(Object.values(firmMap))).sort(), [firmMap]);

    const filtered = useMemo(() => {
        const term = filters.search.trim().toLowerCase();
        const start = filters.startDate ? new Date(filters.startDate + 'T00:00:00') : null;
        const end = filters.endDate ? new Date(filters.endDate + 'T23:59:59') : null;
        return rows.filter(r => {
            if (filters.status && r.status !== filters.status) return false;
            if (filters.panelId && r.panelId !== filters.panelId) return false;
            if (filters.firma && firmMap[r.panelId] !== filters.firma) return false;
            const d = new Date(r.createdAt);
            if (start && d < start) return false;
            if (end && d > end) return false;
            if (term) {
                const hay = [r.siteTransactionNo, r._id, r.username, r.name, r.bank, String(r.amount), firmMap[r.panelId]]
                    .map(x => (x || '').toString().toLowerCase());
                if (!hay.some(x => x.includes(term))) return false;
            }
            return true;
        });
    }, [rows, filters, firmMap]);

    const inputStyle = { width: '100%', padding: '8px', border: '1px solid var(--input-border)', borderRadius: '4px', boxSizing: 'border-box', backgroundColor: 'var(--input-bg)', color: 'var(--text-color)' };
    const th = { padding: '10px', textAlign: 'left' };
    const td = { padding: '10px' };

    return (
        <div style={{ padding: '20px', color: 'var(--text-color)' }}>
            <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ background: '#dc3545', color: '#fff', padding: '4px 14px', borderRadius: '6px', fontSize: '0.55em', fontWeight: 'bold', letterSpacing: '1px' }}>ÇEKİM</span>
                Tüm Çekimler (tüm paneller)
            </h2>

            <div style={{ background: 'var(--card-bg)', padding: '16px', borderRadius: '8px', marginBottom: '16px', boxShadow: 'var(--shadow)', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px' }}>
                <input placeholder="Ara: ID, isim, kullanıcı, IBAN, tutar..." value={filters.search} onChange={e => setFilters({ ...filters, search: e.target.value })} style={inputStyle} />
                <select value={filters.status} onChange={e => setFilters({ ...filters, status: e.target.value })} style={inputStyle}>
                    <option value="">Tüm Durumlar</option>
                    <option value="new">Yeni</option>
                    <option value="processing">İşlemde</option>
                    <option value="awaiting_mgmt">Dekont Kontrolünde</option>
                    <option value="approved">Onaylandı</option>
                    <option value="rejected">Reddedildi</option>
                </select>
                <select value={filters.panelId} onChange={e => setFilters({ ...filters, panelId: e.target.value })} style={inputStyle}>
                    <option value="">Tüm Paneller</option>
                    {panels.map(p => <option key={p._id} value={p.panelId}>{p.name || p.panelId}</option>)}
                </select>
                <select value={filters.firma} onChange={e => setFilters({ ...filters, firma: e.target.value })} style={inputStyle}>
                    <option value="">Tüm Firmalar</option>
                    {firmaOptions.map(f => <option key={f} value={f}>{f}</option>)}
                </select>
                <input type="date" value={filters.startDate} onChange={e => setFilters({ ...filters, startDate: e.target.value })} style={inputStyle} />
                <input type="date" value={filters.endDate} onChange={e => setFilters({ ...filters, endDate: e.target.value })} style={inputStyle} />
            </div>

            <div style={{ background: 'var(--card-bg)', borderRadius: '10px', padding: '16px', boxShadow: 'var(--shadow)', overflowX: 'auto' }}>
                <div style={{ marginBottom: '8px', fontSize: '0.85em', opacity: 0.7 }}>{filtered.length} kayıt</div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
                    <thead>
                        <tr style={{ borderBottom: '2px solid var(--border-color)' }}>
                            <th style={th}>ID</th><th style={th}>İsim Soyisim</th><th style={th}>Kullanıcı Adı</th>
                            <th style={th}>Banka / IBAN</th><th style={th}>Miktar</th><th style={th}>Panel</th><th style={th}>Firma</th>
                            <th style={th}>İşlemi Yapan</th><th style={{ ...th, textAlign: 'center' }}>Durum</th><th style={th}>Tarih</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.length === 0 ? (
                            <tr><td colSpan="10" style={{ padding: '14px', textAlign: 'center', opacity: 0.7 }}>Kayıt yok.</td></tr>
                        ) : filtered.map(r => (
                            <tr key={r._id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                                <td style={td}>{r.siteTransactionNo || ('#' + String(r._id).slice(-6))}</td>
                                <td style={td}>{r.name}</td>
                                <td style={td}>{r.username}</td>
                                <td style={{ ...td, fontSize: '0.85em' }}>{r.bank}</td>
                                <td style={{ ...td, fontWeight: 'bold' }}>{fmt(r.amount)}</td>
                                <td style={td}>{panelName(r.panelId)}</td>
                                <td style={{ ...td, fontWeight: 'bold' }}>{firmaName(r.panelId)}</td>
                                <td style={td}>{r.processedBy || '-'}</td>
                                <td style={{ ...td, textAlign: 'center' }}><span style={{ background: statusColor(r.status), color: '#fff', padding: '3px 8px', borderRadius: '4px', fontSize: '0.8em', fontWeight: 'bold' }}>{statusLabel(r.status)}</span></td>
                                <td style={td}>{new Date(r.createdAt).toLocaleString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AllWithdrawalsPage;
